import "./pozicioneVakante.css";
import PozicioneVakantePDF from "../../Assets/Documents/Pozicione Vakante.PDF";
import PozicioneVakanteAdministrator from "../../Assets/Documents/Pozicion Vakant Administrator.pdf";

const PozicioneVakante = () => {
  const pozicionet = [
    {
      emri: "Specialist në Sektorin e Financës dhe Buxhetit, në Drejtorinë e Financës dhe Shërbimeve Mbështetëse, në Drejtorinë e Përgjithshme të Arkivave, klasa e pagës IV-3",
      data: "16/04/2026",
      link: "https://rekrutimi.administrata.al/shpalljet/shfaq/7281",
    },
    {
      emri: [
        {
          text: "Specialist në Sektorin e Mediave dhe Audiovizual, në Drejtorinë e Promovimit, në Drejtorinë e Përgjithshme të Arkivave - klasa e pagës: IV-2 (Shkenca Komunikimi/Gazetari)",
        },
        {
          text: "Specialist në Sektorin e Eventeve dhe Ekspozitave, në Drejtorinë e Promovimit, në Drejtorinë e Përgjithshme të Arkivave - klasa e pagës: IV-3 (Arte të Bukura)",
        },
      ],
      data: "12/05/2026",
      link: "https://rekrutimi.administrata.al/shpalljet/shfaq/7337",
    },
    {
      emri: "Përgjegjës i Sektorit të Testimeve, Libërlidhjes dhe Mikrofilmimit, në Drejtorinë e Shërbimeve Arkivore, në Drejtorinë e Përgjithshme të Arkivave, klasa e pagës III-2",
      data: "12/05/2026",
      link: "https://rekrutimi.administrata.al/shpalljet/shfaq/7335",
    },
    {
      emri: "Specialist në Sektorin e Gjuhëve të Rralla, në Drejtorinë e Punës me Dokumentet, në Drejtorinë e Përgjithshme të Arkivave, klasa e pagës IV-2",
      data: "12/05/2026",
      link: "https://rekrutimi.administrata.al/shpalljet/shfaq/7336",
    },
    {
      emri: "Punonjës Arkive me kontratë individuale pune, Klasa e pagës VI",
      data: "19/05/2026",
      link: PozicioneVakantePDF,
    },
    {
      emri: "Administrator Dokumentesh në Sektorin e Shërbimit ndaj Studiuesve, në Drejtorinë e Shërbimeve Arkivore, në Drejtorinë e Përgjithshme të Arkivave, klasa e pagës V",
      data: "16/06/2026",
      link: PozicioneVakanteAdministrator,
    },
  ];

  return (
    <div className="page">
      <div className="page-header">
        <div className="headerTitleLine"></div>
        <h1 className="page-title">Pozicione Vakante</h1>
      </div>

      <div className="page-content-karriera">
        <table className="pozicione-table">
          <thead>
            <tr>
              <th>Emërtimi i pozicionit</th>
              <th>Data e shpalljes</th>
            </tr>
          </thead>
          <tbody>
            {pozicionet.map((poz, index) => (
              <tr key={index}>
                <td>
                  <div className="poz-title">
                    <a
                      href={poz.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="poz-link"
                    >
                      {Array.isArray(poz.emri) ? (
                        <ol className="poz-list">
                          {poz.emri.map((item, i) => (
                            <li key={i}>{item.text}</li>
                          ))}
                        </ol>
                      ) : (
                        poz.emri
                      )}
                    </a>
                  </div>
                </td>

                <td className="poz-data">{poz.data}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PozicioneVakante;
